import { Banner, BannerItem } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';

export default function Fido2SkipEnrollmentErrorBanner() {
  const HEADER_TEXT = getLocalizedString('error.fido2skipenrollment.header');
  const DESCRIPTION_PART1 = getLocalizedString('error.fido2skipenrollment.description.part1');
  const DESCRIPTION_DISMISS = getLocalizedString('error.fido2skipenrollment.description.dismiss');
  const DESCRIPTION_PART2 = getLocalizedString('error.fido2skipenrollment.description.part2');

  return (
    <Banner alertType='critical' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {DESCRIPTION_PART1}
        <strong>{DESCRIPTION_DISMISS}</strong>
        {DESCRIPTION_PART2}
      </BannerItem>
    </Banner>
  );
}
